import { atom } from 'recoil';

export const ttsVoiceModal = atom<boolean>({
    key: 'tts-voice-modal',
    default: false,
});

export const ttsUpgradePlanModal = atom<boolean>({
    key: 'tts-upgrade-plan-modal',
    default: false,
});

export const ttsSignupModal = atom<boolean>({
    key: 'tts-signup-modal',
    default: false,
});

export const enterpriseCloneVoiceModal = atom<boolean>({
    key: 'enterprise-clone-voice-modal',
    default: false,
});

export const cloneVoiceWizardModal = atom<boolean>({
    key: 'clone-voice-wizard-modal',
    default: false,
});

export const cloneVoiceUpgradePlanModal = atom<boolean>({
    key: 'upgrade-clone-voice-modal',
    default: false,
});
